import { ChangeDetectionStrategy, Component, Signal, computed } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';

import { selectIsLinearCheckboxesEnabled } from '../../../base/store/selectors';
import { BetslipType } from '../../../core/betslip-type';
import { BETSLIP_TYPE_PROVIDER } from '../../../digital/services/betslip-type-provider.service';
import { IBetslipInfoMessage } from '../../common/models';
import { IErrorComponentDisplayConfig } from '../../validation/models/models';
import BetslipSystemBetActions from '../actions';
import { selectIsSystemBetExpanded } from '../selectors';
import BaseSystemBetComponent from './base-system-bet.component';

@Component({
    selector: 'bs-system-bet-linear',
    templateUrl: './system-bet-linear.component.html',
    styleUrls: ['./system-bet-linear.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: BETSLIP_TYPE_PROVIDER, useValue: new BehaviorSubject(BetslipType.System).asObservable() }],
    standalone: false,
})
export default class SystemBetLinearComponent extends BaseSystemBetComponent {
    protected defaultExpanded: Signal<boolean>;
    showSystemInfo = false;
    betslipInfoMessage: IBetslipInfoMessage;

    protected readonly showSelectionCheckboxes: Signal<boolean>;

    errorDisplayConfig: IErrorComponentDisplayConfig;
    showPickList = computed(() => this.showSelectionCheckboxes() || this.isBankerActiveSignal());

    constructor(
        public sitecore: Sitecore,
        store: Store,
    ) {
        super(store);

        this.betslipInfoMessage = {
            header: this.sitecore.betslip.linearBetslipInfoPopup.SystemHelpHeader,
            infoText: this.sitecore.betslip.linearBetslipInfoPopup.SystemHelpText,
            closeText: this.sitecore.betslip.linearBetslipInfoPopup.InfoPopupHelpClose,
        };

        this.defaultExpanded = store.selectSignal(selectIsSystemBetExpanded);
        this.showSelectionCheckboxes = store.selectSignal(selectIsLinearCheckboxesEnabled);
    }

    protected toggleExpand(isExpanded: boolean): void {
        this.store.dispatch(BetslipSystemBetActions.clickExpandLinearSystemBet({ isExpanded }));
    }
}
